import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-rate@2.4.0@rc-rate/es/index.js
// module id = null
// module chunks = 